import React, { useEffect } from 'react';
// Components
import RankedOrderCard from './RankedOrderCard';

/**
 * The orders card list. Pages that page the list themselves (the orders home page) keep
 * loadMoreOnScreen off; the ones that rely on the list to ask for the next page - the
 * express listing - turn it on, same contract the legacy OrdersList had.
 */
const RankedOrdersList = ({
  ordersListData,
  initialParams,
  fetchMoreData,
  onScreen,
  isLoading,
  loadMoreOnScreen = false,
  emptyText = 'No orders',
  isMyTasks = false,
}) => {
  useEffect(() => {
    if (loadMoreOnScreen && onScreen && !isLoading) {
      fetchMoreData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onScreen]);

  return (
    <div className="ranked-orders-list">
      {ordersListData?.length > 0 ? (
        ordersListData.map((item) => (
          <RankedOrderCard
            key={item?.id}
            item={item}
            initialParams={initialParams}
            fetchMoreData={fetchMoreData}
            isMyTasks={isMyTasks}
          />
        ))
      ) : (
        <h4 className="no-orders-title">{isLoading ? '' : emptyText}</h4>
      )}
    </div>
  );
};

export default RankedOrdersList;
